import { RAW_HOUSES } from "../data/houses";

export function normalizeHouseNo(value = "") {
  return String(value || "").trim().toUpperCase();
}

export function findResidentByHouseNo(houseNo, residents = RAW_HOUSES) {
  const target = normalizeHouseNo(houseNo);
  if (!target) return null;

  return residents.find((resident) => normalizeHouseNo(resident?.nomor_rumah) === target) || null;
}

export function buildResidentFromDefaultData(houseNo, residents = RAW_HOUSES) {
  const resident = findResidentByHouseNo(houseNo, residents);
  if (!resident) return null;

  return {
    nomor_rumah: resident.nomor_rumah,
    nama: resident.nama,
    no_hp: resident.no_hp || "",
    pin: normalizeHouseNo(houseNo),
    aktif: true,
  };
}

export function resolveResidentProfile({ enteredName = "", houseNo, resident }) {
  const safeName = String(enteredName || "").trim();
  const defaultName = resident?.nama || "";

  return {
    nomor_rumah: resident?.nomor_rumah || normalizeHouseNo(houseNo),
    nama: safeName || defaultName,
  };
}
